import React, { useState } from 'react'
import { CustomButton, ModalMockTicket } from 'components'
import close from 'images/closeBanner.svg'
import c from 'classnames'
import './index.styl'
import { isVenue } from 'utils'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

export default ({ onClose, inRow = false }) => {
  const [fadeOut, setFadeOut] = useState(false)
  const [showMockTicket, setShowMockTicket] = useState(false)
  const { user } = useSelector(state => state?.session)
  const { pathname } = useLocation()
  return (
    <>
      {isVenue(user?.role) && !pathname.includes('make-my-tickets') || !isVenue(user?.role) ? (
        <div className={c(pathname.includes('make-my-tickets') ? 'banner-mock-my-ticket' : 'banner-mock-ticket', { inRow })}>
          <div className={c('banner', { fadeIn: !fadeOut, fadeOut: fadeOut })}>
            <img
              src={close} alt='close' className='close' onClick={() => {
                setFadeOut(true)
                // SOU-22.1: the dual promo row hides both halves once the fade-out animation (0.5s) is done
                if (onClose) setTimeout(onClose, 500)
              }}
            />
            <div className='flex-container'>
              <div className='infoWrapper'>
                <div className='info'>
                  <div className='description'>
                    <span className='text'>Master your own ticket...</span>
                    <span className='text'>Live your best lyfe</span>
                  </div>
                </div>
                <div className='title'>Make a Sample Ticket Now</div>
              </div>
              <CustomButton className='button' text='Try It' type='darkInverse' onClick={() => setShowMockTicket(true)} />
            </div>
          </div>
        </div>
      ) : (null)}
      {showMockTicket && <ModalMockTicket onCloseModal={() => setShowMockTicket(false)} />}
    </>

  )
}
